import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { useI18n } from '../../i18n';

interface ContractFailedMessageProps {
  onRetry?: () => void;
  disabled?: boolean;
}

/** A contract generation that didn't finish, with a way to run it again */
export const ContractFailedMessage: React.FC<ContractFailedMessageProps> = ({ onRetry, disabled }) => {
  const { t } = useI18n();

  return (
    <div className="rounded-xl border border-destructive/30 bg-destructive/5 overflow-hidden">
      <div className="px-4 py-3 flex items-start gap-3">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-background border border-destructive/30 text-destructive flex-shrink-0">
          <AlertTriangle className="h-4 w-4" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground">
            {t.qagentChat.contract.generationFailedTitle}
          </p>
          <p className="text-xs text-muted-foreground mt-0.5">
            {t.qagentChat.contract.generationFailedBody}
          </p>
        </div>
        {onRetry && (
          <button
            onClick={onRetry}
            disabled={disabled}
            className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-brand bg-background border border-brand/30 rounded-md hover:bg-brand-light transition-colors flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <RotateCcw className="h-3.5 w-3.5" />
            {t.qagentChat.contract.generationRetry}
          </button>
        )}
      </div>
    </div>
  );
};
